import { useEffect, useState } from "react";
import { Backdrop, Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useSelector } from "react-redux";

// Hanya tampilkan overlay jika request API benar-benar terasa lama,
// dan jangan berkedip untuk request beruntun (< DELAY_HIDE ms).
const DELAY_SHOW = 350;
const DELAY_HIDE = 150;

const LoadingBackdrop = () => {
  const theme = useTheme();
  const { isLoading } = useSelector((state) => state.global);
  const [visible, setVisible] = useState(false);
  const accent = theme.palette.secondary.main;

  useEffect(() => {
    let timer;
    if (isLoading) {
      timer = setTimeout(() => setVisible(true), DELAY_SHOW);
    } else {
      timer = setTimeout(() => setVisible(false), DELAY_HIDE);
    }
    return () => clearTimeout(timer);
  }, [isLoading]);

  return (
    <Backdrop
      open={visible}
      sx={{
        zIndex: 9999,
        backgroundColor: alpha(theme.palette.primary[900], 0.35),
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: 3,
          py: 1.75,
          borderRadius: "999px",
          backgroundColor: alpha(theme.palette.background.paper, 0.72),
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          border: `1px solid ${alpha(theme.palette.primary[900], 0.08)}`,
          boxShadow: "0 12px 32px rgba(17, 31, 55, 0.18)",
          animation: "primaFloatIn 0.25s ease-out",
          "@keyframes primaFloatIn": {
            from: { opacity: 0, transform: "translateY(8px) scale(0.97)" },
            to: { opacity: 1, transform: "translateY(0) scale(1)" },
          },
        }}
      >
        {/* Gradient ring spinner */}
        <Box
          sx={{
            width: 22,
            height: 22,
            flexShrink: 0,
            borderRadius: "50%",
            background: `conic-gradient(from 90deg, transparent 0%, ${alpha(accent, 0.25)} 40%, ${accent} 100%)`,
            WebkitMask:
              "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2.5px))",
            mask: "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2.5px))",
            animation: "primaSpin 0.8s linear infinite",
            "@keyframes primaSpin": {
              to: { transform: "rotate(360deg)" },
            },
          }}
        />
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 14,
            letterSpacing: "-0.01em",
            color: "text.primary",
          }}
        >
          Memuat…
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default LoadingBackdrop;
